import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  priority?: boolean;
  onLoad?: () => void;
}
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  aspectRatio,
  objectFit = 'cover',
  priority = false,
  onLoad
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const handleLoad = () => {
    setIsLoaded(true);
    onLoad?.();
  };
  const handleError = () => {
    setHasError(true);
  };
  return <div className={`relative overflow-hidden bg-gray-100 ${className}`} style={aspectRatio ? {
    aspectRatio
  } : undefined} data-id="element-623">
      {!isLoaded && !hasError && <div className="absolute inset-0 flex items-center justify-center" data-id="element-624">
          <div className="w-8 h-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" data-id="element-625"></div>
        </div>}
      {hasError ? <div className="absolute inset-0 flex items-center justify-center bg-gray-200" data-id="element-626">
          <div className="text-center p-4" data-id="element-627">
            <div className="text-gray-400 mb-2" data-id="element-628">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-629">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-630" />
              </svg>
            </div>
            <p className="text-sm text-gray-500" data-id="element-631">Image unavailable</p>
          </div>
        </div> : <motion.img src={src} alt={alt} loading={priority ? 'eager' : 'lazy'} onLoad={handleLoad} onError={handleError} className={`w-full h-full object-${objectFit} transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} initial={{
      opacity: 0
    }} animate={{
      opacity: isLoaded ? 1 : 0
    }} transition={{
      duration: 0.3
    }} data-id="element-632" />}
    </div>;
};
export default OptimizedImage;